import { server } from "../api";
import axios from "axios";

export default {
  CableOn: async (IP, port, name) => {
    let response = await axios.get(`http://${IP}:${port}/onn`, {
      params: { nodeID: 1, name },
    });
    return response.data;
  },

  CableOff: async (IP, port, name) => {
    let response = await axios.get(`http://${IP}:${port}/off`, {
      params: { nodeID: 1, name },
    });
    return response.data;
  },

  CableInit: async (IP, port) => {
    try {
      let response = await axios.get(`http://${IP}:${port}/init_stat?nodeID=1`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  CableGetData: async (IP, port) => {
    try {
      let response = await axios.get(`http://${IP}:${port}/get_stat`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  CableRestart: async () => {
    try {
      const response = await axios.post(server + "cable/restart");
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  InitPermissionPassword: async (IP, port, permissionID) => {
    try {
      const response = await axios.get(`http://${IP}:${port}/init_perm?id=${permissionID}`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  GetPermissionPassword: async (IP, port, permissionID) => {
    try {
      const response = await axios.get(`http://${IP}:${port}/get_perm?id=${permissionID}`);
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  UpdatePermissionPassword: async (IP, port, permissionID, password) => {
    try {
      const response = await axios.post(`http://${IP}:${port}/update_perm`, {
        permissionID: permissionID,
        password: password
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  },

  UpdatePermissionName: async (mobileID, permissionID, name) => {
    try {
      const response = await axios.post(server + "cable/update_perm_name", {
        mobileID: mobileID,
        permissionID: permissionID,
        name: name
      });
      return response.data;
    } catch (err) {
      return err.response.data;
    }
  }
};
